export default {
  activate: 'pay_now.activate',
  activateModalHeader: 'pay_now.activate.header',
  activateTitle: 'pay_now.activate.title',
  activateMessage: 'pay_now.activate.message',
  getPaidTitle: 'pay_now.getpaid.title',
  getPaidMessage: 'pay_now.getpaid.message',
  noFeesTitle: 'pay_now.nofees.title',
  noFeesMessage: 'pay_now.nofees.message',
  acceptCardTitle: 'pay_now.accept.title',
  acceptCardMessage: 'pay_now.accept.message',
  connectPaynow: 'pay_now.connect_stripe',

  myPayNowHeader: 'pay_now.my_account_view_header',
  authorizationFailureModalHeading: 'pay_now.authorization_failure_modal_heading',
  authorizationFailureInfoTitle: 'pay_now.authorization_failure_info_title',
  authorizationFailureInfoParagraph: 'pay_now.authorization_failure_info_paragraph',
  authorizationSuccessModalHeading: 'pay_now.authorization_success_modal_heading',
  authorizationSuccessInfoTitle: 'pay_now.authorization_success_info_title',
  authorizationSuccessInfoParagraph: 'pay_now.authorization_success_info_paragraph',
  processingAuthorization: 'pay_now.processing_authorization',
  ok: 'pay_now.ok',

  connectedWithStripeTitle: 'pay_now.connected_title',
  connectedWithStripeMessage: 'pay_now.connected_message',
  goToStripe: 'pay_now.go_to_stripe',

  acceptCards: 'pay_now.accept_cards',
  acceptCardsSubLabel: 'pay_now.accept_cards_sub_label',
  disconnectPayNow: 'pay_now.disconnect',
  deleteConfirmationHeader: 'pay_now.delete_confirmation_header',
  deleteConfirmationLabel: 'pay_now.delete_confirmation_label',
  deleteConfirmationSubLabel: 'pay_now.delete_confirmation_sub_label',
  deleteConfirmationButton: 'pay_now.delete_confirmation_button',
  deleteConfirmationCancelButton: 'cancel',

  manageStripeHeader: 'pay_now.manage_stripe_header',
  stripeFeatureAccessToDashboard: 'pay_now.stripe_feature_access_stripe_dashboard',
  stripeFeatureReceipts: 'pay_now.stripe_feature_receipts',
  stripeFeatureRefunds: 'pay_now.stripe_feature_refunds',
  stripeFeaturePaymentIssues: 'pay_now.stripe_feature_payment_issues',
  stripeFeaturePaymentReconciliationIssues: 'pay_now.stripe_feature_reconciliation_issues',
  disconnectHeader: 'pay_now.disconnect_header',
  disconnectMessage: 'pay_now.disconnect_message',
}
